<template>
  <div>
    <div class="form-group">
      <el-form-item label="Placeholder (Range Values)">
        <el-input v-model="field.placeholder1"></el-input>
      </el-form-item>
    </div>
  </div>
</template>

<script>
export default {
  name:"templates-formComponents-Placeholder",
  props: ["field"],
  data() {
    return {};
  }
};
</script>

<style lang="scss">
</style>